<template>
   <div class="ph-logo-a4 p5">
            <a href="#" class="dbi fl he40">
                <img src="../../assets/mobile/images/logo2.png" width="" height="45" alt="" />
            </a>
            <a href="#" class="dbi fr he20 white pr10 mt14 mr12" @click="menuClick">
                <span class="f14 txtsh mr5">MENU</span>
                <i class="fa fa-bars f18 txtsh">
                </i>
            </a>
        </div>
        <!--弹出菜单-->
        <!--  WOW animate__animated animate__fadeInRight -->
        <div :class="'ph-phone-mu ' + contentClasses" v-show="menuShowState" @animationend="handleAnimationEnd" style="">
            <ul class="ph-ph-um-ul">
                <li class="ph-ph-mu-li mt10"><a href="/mb/homeWebMb" class="db  f15 lp2 pl10 white txtsh">首页</a>
                </li>
                <li class="ph-ph-mu-li mt10"><a href="/mb/chanping1Mb" class="db white f15 lp2 pl10 txtsh">产品</a>
                    <div class="" style="">
                        <a class="db he34 ml30 ph-pml-a" href="/mb/chanping1Mb">谛视万象多模态视觉大模型</a>
                        <a class="db he34 ml30 ph-pml-a" href="/mb/chanping2Mb">视觉大模型一体机</a>
                        <a class="db he34 ml30 ph-pml-a" href="/mb/chanping3Mb">新一代公共安全视觉智能体</a>
                        <a class="db he34 ml30 ph-pml-a" href="/mb/chanping4Mb">视觉智能体</a>
                    </div>
                </li>
                <li class="ph-ph-mu-li mt10"><a href="/mb/jiejfa1Mb" class="db white txtsh f15 lp2 pl10">解决方案</a>
                    <div class="" style="">
                        <a class="db he34 ml30 ph-pml-a" href="/mb/jiejfa1Mb">公共安全行业解决方案</a>
                        <a class="db he34 ml30 ph-pml-a" href="/mb/yijii2Mb">应急行业解决方案</a>
                        <a class="db he34 ml30 ph-pml-a" href="/mb/chengguan3Mb">城管行业解决方案</a>
                        <a class="db he34 ml30 ph-pml-a" href="/mb/jiaotong4Mb">交通行业解决方案</a>
                        <a class="db he34 ml30 ph-pml-a" href="/mb/qiyeigl5Mb">企业管理解决方案</a>
                    </div>
                </li>
                <li class="ph-ph-mu-li mt10"><a href="/mb/severHtmlMb" class="db white txtsh f15 lp2 pl10">服务&生态</a>
                </li>
                <li class="ph-ph-mu-li mt10"><a href="/mb/gywmHtmlMb" class="db white txtsh f15 lp2 pl10">关于我们</a>
                </li>
            </ul>
        </div>
</template>
<script setup>
// onMounted,  onUnmounted,
import { onMounted, ref } from 'vue';
import * as WOW from 'wowjs';

const menuShowState = ref(false)
// const showChangeDpCheck = ref(1)
const contentClasses = ref('')

onMounted(() => {
    // showChangeDp();
    menuShowState.value = false

    new WOW.WOW({
        // boxClass: 'wow',
        animateClass: 'animate__animated',
        offset: 50,       // 元素进入视口 100px 后触发
        // mobile: true,      // 移动端启用
        live: true,        // 监听动态添加的元素
    }).init();
})

function menuClick() {
    if (!menuShowState.value) {
        contentClasses.value = 'WOW animate__animated animate__fadeInRight'
        menuShowState.value = true
    }
    else {
        contentClasses.value = 'WOW animate__animated animate__fadeOutRight'
    }
    // menuShowState.value = !menuShowState.value
}

function handleAnimationEnd() {
    if (menuShowState.value && contentClasses.value == 'WOW animate__animated animate__fadeOutRight') {
        menuShowState.value = false
    }
}

// function showChangeDp() {
//     setTimeout(() => {
//         loopShowFunc()
//         showChangeDp()
//     }, 4000);
// }

// function loopShowFunc() {
//     if (showChangeDpCheck.value < 4) {
//         showChangeDpCheck.value = showChangeDpCheck.value + 1
//     }
//     else {
//         showChangeDpCheck.value = 1
//     }
// }

// function addAndDelFunc(typeState) {
//     if (typeState == 'add') {
//         // showChangeDpCheck.value
//         if (showChangeDpCheck.value < 4) {
//             showChangeDpCheck.value = showChangeDpCheck.value + 1
//         }
//         else {
//             showChangeDpCheck.value = 1
//         }
//     }
//     if (typeState == 'del') {
//         if (showChangeDpCheck.value != 1) {
//             showChangeDpCheck.value = showChangeDpCheck.value - 1
//         }
//         else {
//             showChangeDpCheck.value = 4
//         }
//     }
// }

// function checkMunFunc(checkNum) {
//     showChangeDpCheck.value = checkNum
// }

// const beforeEnter = (el) => {
//     el.style.opacity = 0;
//     el.style.transform = 'translateY(-20px)';
// };
// const enter = (el, done) => {
//     requestAnimationFrame(() => {
//         el.style.transition = 'opacity 0.5s ease, transform 0.3s ease';
//         el.style.opacity = 1;
//         el.style.transform = 'translateY(0)';
//         done(); // 动画完成后调用
//     });
// };

// const leave = (el, done) => {
//     el.style.transition = 'opacity 0.5s ease, transform 0.3s ease';
//     el.style.opacity = 0;
//     el.style.transform = 'translateY(-20px)';
//     setTimeout(done, 300);
// };



</script>
<style scoped>
@import '@/assets/mobile/css/default.css';
@import '@/assets/mobile/css/font-awesome.min.css';
@import '@/assets/mobile/css/margin.css';
@import '@/assets/mobile/css/main.css';

.img1 {
    background: url(../../assets/mobile/images/bana-1.jpg) center center no-repeat;
    background-size: cover;
}

.img2 {
    background: url(../../assets/mobile/images/bana-2.jpg) center center no-repeat;
    background-size: cover;
}

.img3 {
    background: url(../../assets/mobile/images/bana-4.jpg) center center no-repeat;
    background-size: cover;
}

.img4 {
    background: url(../../assets/mobile/images/bana-3.jpg) center center no-repeat;
    background-size: cover;
}

.animate__animated {
    animation-duration: 2s !important;
}

@layer utilities {
    .content-auto {
        content-visibility: auto;
    }

    .bg-zoom-container {
        overflow: hidden;
        position: relative;
        height: 100vh;
        width: 100%;
    }

    .bg-animated {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-position: center;
        background-repeat: no-repeat;
        background-size: cover;
        animation: zoomIn 9s infinite alternate ease-in-out;
    }
}


@keyframes zoomIn {
    0% {
        transform: scale(1);
    }

    100% {
        transform: scale(1.5);
    }
}
</style>